module.exports = function () {
  var $el = $('.accordion, #accordion')

  var $heading = $el.find('h3')

  $heading.on('click', function () {
    $(this).toggleClass('open')
    $(this).next('.collapse').toggleClass('visible')
  })
}
